import { useCallback } from 'react'

import { Item, ItemType, MIME_TYPES } from '@inno-sdks/files'
import axios from 'axios'
import { useTranslation } from 'react-i18next'

import { useDownloadAsZipMutation } from '../../api/requests/downloadAsZip'
import { useDownloaderStore } from '../../store/downloadStore'
import { downloadFile, getRandomId } from '../../utils'

export type DownloadableItem = { id: number; name: string }

export const useDownloadAsZip = () => {
  const {
    addItem,
    markCompleted,
    markFailed,
    cancelDownload,
    downloadProgress
  } = useDownloaderStore()

  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop'
  })

  const { mutateAsync } = useDownloadAsZipMutation()

  return useCallback(async (items: Array<DownloadableItem>) => {
    const abortController = new AbortController()

    const activityId = getRandomId()
    const label = `${items.length === 1 ? items[0].name : t('archived-items')}.zip`

    try {
      addItem({
        id: activityId,
        label,
        progress: 0,
        abortController,
        item: {
          id: activityId,
          name: label,
          type: ItemType.File,
          metaData: {
            mimeType: MIME_TYPES.archive.zip
          }
        } as Item,
        status: 'pending',
        onCancel: () => cancelDownload(activityId)
      })

      const blob = await mutateAsync({
        itemIds: items.map(item => item.id),
        onProgress: progress => downloadProgress(activityId, progress),
        abortController
      })

      downloadFile(blob, label)
      markCompleted(activityId)
    } catch (error) {
      if (!axios.isCancel(error)) {
        markFailed(activityId)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
